import React from 'react';
import './event_members.css';

const members = [
  {
    id: 1,
    image: 'https://via.placeholder.com/600x400?text=Member+1',
    title: 'Ali Khan',
    desc: 'Founder — Building PropTech solutions for smarter urban living.'
  },
  {
    id: 2,
    image: 'https://via.placeholder.com/600x400?text=Member+2',
    title: 'Sara Ahmed',
    desc: 'Community Lead — Organising events and member engagement.'
  },
  {
    id: 3,
    image: 'https://via.placeholder.com/600x400?text=Member+3',
    title: 'Bilal Riaz',
    desc: 'Events Coordinator — Curating meetups and workshops.'
  },
  {
    id: 4,
    image: 'https://via.placeholder.com/600x400?text=Member+4',
    title: 'Maya Iqbal',
    desc: 'Marketing — Growing awareness and partnerships.'
  },
  {
    id: 5,
    image: 'https://via.placeholder.com/600x400?text=Member+5',
    title: 'Omar Farooq',
    desc: 'Design Lead — Creating delightful product experiences.'
  },
  {
    id: 6,
    image: 'https://via.placeholder.com/600x400?text=Member+6',
    title: 'Nadia Hussain',
    desc: 'Partnerships — Connecting members with opportunities.'
  },
  {
    id: 7,
    image: 'https://via.placeholder.com/600x400?text=Member+7',
    title: 'Hassan Ali',
    desc: 'Investor — Focused on PropTech investments and growth.'
  },
  {
    id: 8,
    image: 'https://via.placeholder.com/600x400?text=Member+8',
    title: 'Lina Karim',
    desc: 'Product Manager — Scaling property marketplace solutions.'
  }
];

const EventMembers = () => {
  return (
    <section id="event_members_section">


        
      <h1 className="members_hdng">PropTech Club Members</h1>

      <div className="members_grid">
        {members.map((m) => (
          <article className="member_card" key={m.id}>
            <div className="member_card_img_wrap">
              <img className="member_card_img" src={m.image} alt={m.title} />
            </div>
            <div className="member_card_body">
              <h3 className="member_card_title">{m.title}</h3>
              <p className="member_card_desc">{m.desc}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default EventMembers;
